enum DocumentTypes {
  PurchaseAgreementElectronicConsent = 'E_CONSENT',
  PurchaseAgreementPrivacyPolicy = 'PRIVACY_POLICY',
  PurchaseAgreementArbitrationAgreement = 'ARBITRATION',
  PurchaseAgreementAgreementCpa = 'CPA',
  PurchaseAgreementSunbitAgreementPrivacy = 'PRIVACY_AGREEMENT',
  PurchaseAgreementCaliforniaPrivacy = 'PRIVACY_POLICY_CALIFORNIA',
  PurchaseAgreementAgreementGlba = 'GLBA',
  PurchaseAgreementAgreementGlbaTab = 'GLBA_TAB',
  SunbitOnlineServicesTermsOfUse = 'TERMS_OF_USE',
  MxUserAgreement = 'MX_USER_AGREEMENT',
  TermsAndConditions = 'TERMS_AND_CONDITIONS',
  HomeServicesCancellationForm = 'home-services-cancellation-form',
  LoanPaymentDisclosure = 'loan-payment-disclosure',

  // Card Application
  CardApplicationCreditPullAuthorizarion = 'CREDIT_PULL_AUTHRIZATION',
  CardApplicationElectronicConsent = 'ELECTRONIC_CONSENT',
  CardApplicationTermsAndConditions = 'TERMS_AND_CONDITIONS',
  CardApplicationCreditScoreNotice = 'CREDIT_SCORE_NOTICE',
  CardApplicationSolicitationDisclosures = 'SOLICITATION_DISCLOSURES',
  CardApplicationRecurringPaymentAuthorization = 'RECURRING_PAYMENT_AUTHRIZATION',
  CardApplicationPrivacyChoices = 'PRIVACY_CHOICES',
  CardApplicationCashRewards = 'CASH_REWARDS',
  CardApplicationArbitrationProvision = 'ARBITRATION_PROVISION',
  CardApplicationOnlineServicesTermsOfUse = 'ONLINE_SERVICES_TERMS_OF_USE',
}

export enum DocumentTypesTypes {
  PurchaseAgreementElectronicConsent = 'PurchaseAgreementElectronicConsent',
  PurchaseAgreementPrivacyPolicy = 'PurchaseAgreementPrivacyPolicy',
  TermsAndConditions = 'TermsAndConditions',
  PurchaseAgreementArbitrationAgreement = 'PurchaseAgreementArbitrationAgreement',
  PurchaseAgreementAgreementCpa = 'PurchaseAgreementAgreementCpa',
  PurchaseAgreementSunbitAgreementPrivacy = 'PurchaseAgreementSunbitAgreementPrivacy',
  PurchaseAgreementCaliforniaPrivacy = 'PurchaseAgreementCaliforniaPrivacy',
  PurchaseAgreementAgreementGlba = 'PurchaseAgreementAgreementGlba',
  PurchaseAgreementAgreementGlbaTab = 'PurchaseAgreementAgreementGlbaTab',
  SunbitOnlineServicesTermsOfUse = 'SunbitOnlineServicesTermsOfUse',
  MxUserAgreement = 'MxUserAgreement',

  // Card Application
  CardApplicationCreditPullAuthorizarion = 'CardApplicationCreditPullAuthorizarion',
  CardApplicationElectronicConsent = 'CardApplicationElectronicConsent',
  CardApplicationCreditScoreNotice = 'CardApplicationCreditScoreNotice',
  CardApplicationSolicitationDisclosures = 'CardApplicationSolicitationDisclosures',
  CardApplicationRecurringPaymentAuthorization = 'CardApplicationRecurringPaymentAuthorization',
  CardApplicationPrivacyChoices = 'CardApplicationPrivacyChoices',
  CardApplicationArbitrationProvision = 'CardApplicationArbitrationProvision',
  CardApplicationOnlineServicesTermsOfUse = 'CardApplicationOnlineServicesTermsOfUse',
}

export default DocumentTypes;
